module.exports = __webpack_public_path__ + "static/media/en.cbbeb746.svg";